import { useEffect, useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import * as Yup from 'yup'
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";

export default function AffilationLabCourseMap() {
    const [labs, setLabs] = useState([]);
    const dispatch = useDispatch()
    const [flag, setFlag] = useState(false);
    const [courseCode, setCourseCode] = useState('');
    const [labname, setlabname] = useState('');

    const validationSchema = Yup.object().shape({
        labDetails: Yup.array().of(
            Yup.object().shape({
                labDetails: Yup.string().required(ERROR_MSG),
            })
        ),
    });

    const labEquipFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            courseCode: courseCode || '',
            labDetails: [{
                labDetails: ""
            }],
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            labEquipFormik.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                    const labfinalvalues = {
                        courseCode: courseCode || '',
                        labDetails: val?.labDetails?.map((item) => item?.labDetails),
                    };
                    Swal.fire({
                        text: 'Are you sure you want to submit?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, submit it!',
                        cancelButtonText: 'No, cancel!',
                        backdrop: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const url = config.url.API_URL + `LabAreaMappingDetails`;
                            CommonAxiosPost(url, labfinalvalues, dispatch).then((res) => {
                                if (res?.data?.scode === '01') {
                                    Swal.fire(res?.data?.sdesc, '', 'success').then(() => {
                                        window.location.reload();
                                    });
                                } else {
                                    failureAlert("Failed to submit")
                                }
                            });
                        }
                    });
                } else {
                    console.log('Validation errors:', errors);
                }
            });
        },
    });

    const [getLabMap, setLabMap] = useState('');
    function LabmappingData() {
        let url = config.url.API_URL + `labMapCourses`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLabMap(res?.data?.labMapCourses)
            } else {
                setLabMap([])
            }
        })
    }

    async function GetLabDetails() {
        try {
            const urll = `${config.url.API_URL}getlabs`;
            const res2 = await CommonAxiosGet(urll, dispatch);
            if (res2?.data?.scode === '01') {
                setLabs(res2?.data?.labs);
            } else {
                setLabs([]);
            }
        } catch (error) {
            console.error('Error fetching labs:', error);
            setLabs([]);
        }
    }
    const [lanDetails, setabDetails] = useState([])

    async function GetLablist(crsId) {
        if (!crsId) {
            return;
        }
        try {
            const urll = `${config.url.API_URL}getlabsList/${crsId}`;
            const res = await CommonAxiosGet(urll, dispatch);
            if (res?.data?.scode === '01') {
                const fetchedLabs = res?.data?.labsList || [];
                setabDetails(fetchedLabs)

                const areaDetails = fetchedLabs.length > 0
                    ? fetchedLabs.map((lab) => ({
                        labDetails: lab?.lab_details || '',
                    }))
                    : [{ labDetails: '' }];
                labEquipFormik.setFieldValue('labDetails', areaDetails);
            } else {
                console.log("No Data Found")
            }
        } catch (error) {
            console.error('Error fetching labs:', error);
        }
    }
    useEffect(() => {
        LabmappingData();
        GetLablist();

    }, [])


    const Columns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>, },
        { Header: "Academic program type", accessor: "course_group_desc", Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'left' }}>-</b>}</div> },
        { Header: "Course", accessor: "course_cat_name", Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'left' }}>-</b>}</div> },
        { Header: "Branch/combination", accessor: "course_name", Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'left' }}>-</b>}</div> },
        {
            Header: "Total Labs", accessor: "tot",
            Cell: ({ row }) => (
                <div>
                    <button type="button" onClick={(e) => {
                        setFlag(true); GetLabDetails();
                        setCourseCode(row?.original?.course_id);
                        GetLablist(row?.original?.course_id);
                        setlabname(row?.original?.course_name);
                    }}
                        style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                        className='text-center'>
                        {row?.values?.tot === 0 ? 'Please Add Labs' : row?.values?.tot}
                    </button>
                </div>
            )
        }
    ]

    const handleSelectionChange = (selectedValue, index) => {
        const selectedValues = labEquipFormik.values.labDetails
            .map((detail, i) => (i !== index ? detail.labDetails : null))
            .filter((value) => value);
        if (selectedValues.includes(selectedValue)) {
            Swal.fire({
                icon: 'warning',
                title: 'Duplicate Selection',
                text: 'This value is already selected in another row.',
                confirmButtonText: 'OK',
            }).then(() => {
                labEquipFormik.setFieldValue(`labDetails[${index}].labDetails`, '');
            });
        }
    };

    function Deletecoursedata(sl_no, crsId) {
        Swal.fire({
            title: 'Are you sure want to Delete ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    slno: sl_no,
                }

                let url = config.url.API_URL + `deleteLabdetails/` + sl_no + "/" + crsId;
                CommonAxiosPost(url, dispatch).then(res => {
                    if (res?.data?.scode === "01") {
                        Swal.fire(res?.data?.sdesc, '', 'success').then((refresh) => {
                            if (refresh.isConfirmed) {
                                window.location.reload(true)
                            }
                        });
                    } else {
                        failureAlert("Something went wrong,Please check");
                    }
                }
                );

            }
        })
    }
    return (
        <>
            <Container fluid className="px-1" >
                {!flag ? (<>
                    <CommonFormHeading heading={"Laboratory - Course Mapping"} />

                    {/* <bie.Row>
                        <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
                            <div className="inner-herbpage-service-title1">
                                <h1>Laboratory - Course Mapping</h1>
                            </div>
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                            <button className="breadcrumb-item"><a href="/dashboard" className='affl-dash'><FaHome size={30} /></a></button>
                        </bie.Col>
                    </bie.Row> */}
                    <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                        <Alert variant='danger' className='affl-alert'>
                            <p>   <b style={{ color: "red" }}> Note :</b> For any course if any Labs are not required as per the Norms. Then please SAVE and SUBMIT the details of the Labs for Other courses for which Labs are required.
                                It is not mandatory to add Labs for all courses</p>
                        </Alert>

                        {getLabMap && getLabMap?.length > 0 ? (

                            <div className='table-responsive'>
                                <CommonReactTable data={getLabMap} columns={Columns} paginationCount="All" excelFlag={false} printFlag={false} filename="AffiliationLabCourseMap" headerName={`AffiliationLabCourseMap`} />
                            </div>
                        ) : (
                            <b className='text-error text-center'>No data Found</b>
                        )}
                        <br />

                    </Container>
                </>
                ) : (
                    <>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                                <div className="inner-herbpage-service-title1"><h1>{labname} Systems Course</h1></div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                <div className='d-flex flex-row justify-content-end'>
                                    <button type="button" className='btn btn-sm btn-secondary' onClick={() => { setFlag(false); setabDetails([]) }}>Back</button>
                                </div>
                            </Col>

                        </Row>
                        <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }}>
                            <b style={{ color: "red" }}> Note </b> For any course if any Labs are not required as per the Norms. Then please SAVE and SUBMIT the details of the Labs for Other courses for which Labs are required.
                            It is not mandatory to add Labs for all courses
                            <FormikProvider value={labEquipFormik}>
                                <Form onChange={labEquipFormik.handleChange} onSubmit={labEquipFormik.handleSubmit}>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive table-stripped">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Name of the Lab</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="labDetails">
                                                    {({ push, remove }) => (
                                                        <>
                                                            {labEquipFormik?.values?.labDetails?.map((detail, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control" name={`labDetails[${index}].labDetails`} style={{ width: '100%' }}
                                                                            onChange={(e) => { labEquipFormik.handleChange(e); handleSelectionChange(e.target.value, index); }}>
                                                                            <option value="">--Select--</option>
                                                                            {labs?.length > 0 && labs.map((lab, i) => (<option key={i} value={lab.lab_details}>{lab.lab_details}</option>))}
                                                                        </Field>
                                                                        <ErrorMessage name={`labDetails[${index}].labDetails`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 && (
                                                                            <button type="button" className="button-title btn btn-sm btn-success"
                                                                                onClick={() => { push({ labDetails: '' }); }}><VscDiffAdded />
                                                                            </button>
                                                                        )}
                                                                        {index >= 1 && (
                                                                            <button type="button" className="button-title btn btn-sm btn-danger" onClick={() => { remove(index); }}>
                                                                                <BiTrash />
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    )}
                                                </FieldArray>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button type="submit" className="btn btn-success btn-sm float-end">
                                        Submit
                                    </button>


                                    {lanDetails && lanDetails.length > 0 && (<>

                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                                                <div className="inner-herbpage-service-title1"><h1>Lab Course Mapping Report</h1></div>
                                            </Col>
                                        </Row>
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-sm table-responsive table-stripped">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Name of the Lab</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {lanDetails && lanDetails.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{data?.lab_details || '-'}</td>
                                                            <td className='cen'>
                                                                <button
                                                                    type='button'
                                                                    className='btn btn-danger btn-sm mt-2'
                                                                    onClick={() => { Deletecoursedata(data?.slno, data?.course_code) }}
                                                                >
                                                                    Delete


                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                            </table>
                                        </div>
                                    </>)}

                                </Form>
                            </FormikProvider>
                        </Container >
                    </>
                )}
            </Container >

        </>
    )
}

